'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var iframeUuid = function iframeUuid() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return state;
};

exports.default = iframeUuid;
module.exports = exports['default'];